import { useEffect } from 'react';
import { getAppName } from 'utils/getAppName';
import { isSaaS } from 'utils/isSaaS';

/**
 * Компонент для динамического обновления manifest.json
 * Обновляет название приложения в зависимости от типа окружения
 */
export const DynamicManifest: React.FC = () => {
  useEffect(() => {
    const appName = getAppName();

    // Обновляем manifest.json
    const manifest = {
      short_name: appName,
      name: isSaaS() ? appName : `Самолет ${appName}`,
      icons: [
        {
          src: 'icon-192.png',
          type: 'image/png',
          sizes: '192x192',
        },
        {
          src: 'icon-512.png',
          type: 'image/png',
          sizes: '512x512',
        },
      ],
      start_url: '.',
      display: 'standalone',
      theme_color: '#000000',
      background_color: '#ffffff',
    };

    // Создаем новый link элемент для manifest
    const link = document.createElement('link');
    link.rel = 'manifest';

    // Используем encodeURIComponent для безопасного кодирования Unicode символов
    const jsonString = JSON.stringify(manifest);
    const encodedJson = encodeURIComponent(jsonString);
    link.href = `data:application/json;charset=utf-8,${encodedJson}`;

    // Удаляем старый manifest если есть
    const oldLink = document.querySelector('link[rel="manifest"]');
    if (oldLink) {
      oldLink.remove();
    }

    // Добавляем новый manifest
    document.head.appendChild(link);
  }, []);

  return null;
};
